import React from "react";
import SEOHead from "../components/tools/SEOHead";
import MarketingShell, {
  Arrow,
  bookingHref,
  useMarketingCopy,
} from "./MarketingShell";
import marketingRoutes from "./marketingRoutes.json";
import SharePageLink from "./SharePageLink";

export default function BusinessBriefPage({ index }: { index: number }) {
  const { routes } = useMarketingCopy();
  const brief = routes.briefs[index];
  return (
    <MarketingShell active="business">
      <SEOHead
        title={`${brief.title} — YouWo`}
        description={brief.description}
        canonicalUrl={`https://youwo.ai${marketingRoutes.paths[index]}`}
        ogImage="https://youwo.ai/landing/display.png"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "Service",
          name: brief.title,
          description: brief.description,
          url: `https://youwo.ai${marketingRoutes.paths[index]}`,
          provider: { "@type": "Organization", name: "YouWo" },
        }}
      />
      <main id="main-content" tabIndex={-1}>
        <section
          className="quant-wrap destination-hero brief-hero"
          aria-labelledby="brief-title"
        >
          <p className="quant-eyebrow">{brief.label}</p>
          <h1 id="brief-title">{brief.title}</h1>
          <p className="quant-lead">{brief.description}</p>
          <div className="quant-cta-row">
            <a
              className="quant-button"
              href={bookingHref}
              target="_blank"
              rel="noopener noreferrer"
            >
              {routes.scopeCta}
              <Arrow diagonal />
            </a>
            <SharePageLink />
          </div>
        </section>
        <div className="quant-wrap brief-body">
          <ol className="brief-sequence">
            {brief.steps.map((step, index) => (
              <li key={step}>
                <span>0{index + 1}</span>
                <h2>{step}</h2>
              </li>
            ))}
          </ol>
          <dl className="brief-deliverables">
            <div>
              <dt>{routes.startLabel}</dt>
              <dd>{brief.start}</dd>
            </div>
            <div>
              <dt>{routes.deliverLabel}</dt>
              <dd>{brief.deliver}</dd>
            </div>
          </dl>
          <details className="marketing-disclosure">
            <summary>
              {routes.measureLabel}
              <span aria-hidden="true">+</span>
            </summary>
            <p>{brief.measure}</p>
          </details>
          <p className="brief-case">{brief.case}</p>
          <a href="/business" className="quant-text-link">
            {routes.backBusiness}
            <Arrow />
          </a>
        </div>
      </main>
    </MarketingShell>
  );
}
